import React from "react"
import { Link } from "gatsby"
import "./index.scss"
const WidgetFooterLink = ({ data, to }) => {
  return (
    <div
      id="WidgetFooterLink"
      className="WidgetFooterLink"
      data-testid="WidgetFooterLink"
    >
      <Link to={to} className="widget-footer-link">
        {data}
      </Link>
    </div>
  )
}

export default WidgetFooterLink
